<template>
  <CustomModal ref="modal" class="edit-business-modal" title="Modifier les informations">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <div class="form-container">
          <div class="element">
            <CustomSelectField :content=inputs.client />
            <CustomTextField :content=inputs.number />
            <div class="separator"></div>
            <CustomTextAreaField :content=inputs.companyInformation  style="margin-bottom: 15px"/>
          </div>
          <div class="element">
            <CustomSelectField :content=inputs.quoteValidityPeriod />
            <CustomSelectField style="margin-top: 15px" :content=inputs.invoicePaiementPeriod />
            <CustomTextField :content=inputs.tvaNumber />
            <CustomTextAreaField :content=inputs.additionalInformation />
          </div>
        </div>
        <CustomButton class="submit-button" @click="submitForm" :params=buttons.submit style="margin-top: 15px" />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faPlus, faUpLong, faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";
import {ClientController} from "@/controllers/business/ClientController";
import {BUSINESS_STATUS_ENUM} from "@/models/businessStatusEnum";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {isEditableBusiness} from "@/utils";
import CustomTextAreaField from "@/components/forms/customs/customTextAreaField/CustomTextAreaField.vue";
library.add(faXmark);
library.add(faPlus);
library.add(faCheck);
library.add(faUpLong);
library.add(faExclamation);

export default {
  name: 'EditGeneralInfosBusinessModal',
  computed: {
    BUSINESS_STATUS_ENUM() {
      return BUSINESS_STATUS_ENUM
    }
  },
  props: ['callback'],
  components: {
    CustomTextAreaField, CustomModal, CustomForm, CustomSelectField, CustomTextField, CustomButton},
  data() {
    return {
      business: undefined,
      inputs: {
        number: {label: 'N°', value: 1, type: 'number', required: true},
        companyInformation: {label: 'Information entreprise', value: ''},
        tvaNumber: {label: 'Numéro de TVA', value: '', type: 'text'},
        bank: {label: 'Coordonnées bancaires', value: ''},
        additionalInformation: {label: 'Informations complémentaires', value: ''},
        quoteValidityPeriod: {label: 'Période de validité', value: '', type: 'select', selectValues: [{label:"45", value: 45}, {label:"30", value: 30}, {label:"15", value: 15}]},
        invoicePaiementPeriod: {label: 'Délai de paiement', value: '', type: 'select', selectValues: [{label:"45", value: 45}, {label:"30", value: 30}, {label:"15", value: 15}, {label:"A la réception", value: 0}]},
        client: {label: 'Client', value: '...', type: 'select', selectValues: [{label:"TODO", value: "TODO"}], required: true},
      },
      buttons:{
        submit: {text: "Valider"}
      },
      isTerminateButtonDisplayed: false
    };
  },
  methods: {
    openModal(business) {
      this.$refs.modal.openModal();
      this.$refs.form?.startLoading();
      this.business = business;
      this.buttons.submit.disabled = false;
      this.inputs.number.value = business.number;
      this.inputs.companyInformation.value = business.companyInformation;
      this.inputs.tvaNumber.value = business.tvaNumber;
      this.inputs.bank.value = business.bank;
      this.inputs.additionalInformation.value = business.additionalInformation;
      this.inputs.quoteValidityPeriod.value = business.quoteValidityPeriod;
      this.inputs.invoicePaiementPeriod.value = business.invoicePaiementPeriod;

      this.fillClientSelect(business.clientId);

      this.setReadOnlyIfAmendment(!!business.amendmentOfBusinessId);
      this.setReadOnly(!isEditableBusiness(business));

      this.$refs.form?.stopLoading();
    },
    closeModal() {
      this.$refs.modal?.closeModal();
    },
    terminate() {
      this.closeModal();
      this.callback();
    },
    async fillClientSelect(clientId) {
      // Get the table data
      this.inputs.client.selectValues = [];
      const resp = await ClientController.getAll();
      if (!resp.errors) {
        resp.sort((a, b) => a.structuredInformations.name.localeCompare(b.structuredInformations.name));
        for (let i = 0; i < resp.length; i++) {
          this.inputs.client.selectValues.push({label: resp[i].structuredInformations.name, value: resp[i].id});
        }
      }
      this.inputs.client.value = clientId;
    },
    setReadOnly(readOnly) {
      this.inputs.quoteValidityPeriod.readOnly = readOnly;
      this.inputs.invoicePaiementPeriod.readOnly = readOnly;
      this.inputs.bank.readOnly = readOnly;
      this.inputs.additionalInformation.readOnly = readOnly;
      this.inputs.tvaNumber.readOnly = readOnly;
      this.inputs.companyInformation.readOnly = readOnly;
      this.inputs.number.readOnly = readOnly;
      this.inputs.client.readOnly = readOnly;
    },
    setReadOnlyIfAmendment(isAmendment) {
      this.inputs.tvaNumber.readOnly = isAmendment;
      this.inputs.companyInformation.readOnly = isAmendment;
      this.inputs.client.readOnly = isAmendment;
    },
    async submitForm() {
      if (this.business.status === BUSINESS_STATUS_ENUM.DONE.value) {
        this.closeModal();
        return;
      }

      const res = await this.$refs.form.submitForm(() => BusinessController.patch(this.business.id, {
        clientId: this.inputs.client.value,
        number: this.inputs.number.value,
        companyInformation: this.inputs.companyInformation.value,
        tvaNumber: this.inputs.tvaNumber.value,
        quoteValidityPeriod: this.inputs.quoteValidityPeriod.value,
        invoicePaiementPeriod: this.inputs.invoicePaiementPeriod.value,
        bank: this.inputs.bank.value,
        additionalInformation: this.inputs.additionalInformation.value
      }));
      if (!res.errors) {
        (new NotificationService).addNotification("success", "Contrat modifié");
        this.terminate();
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.form-container
  display flex
  flex-direction column

.submit-button
  margin 20px auto auto

@media only screen and (min-width: DESKTOP_SIZE)
  .form-container
    flex-direction row

    .element
      width: calc(100% - 4em)
      padding 2em

  .submit-button
    width 250px

.separator
  margin-top 15px
  margin-bottom 15px
  height 2px
  background-color THEME_COLOR_PRIMARY_FADDED
  opacity 0.6

  .separator-state-container
    width 30px
</style>

<style lang="stylus">
.edit-business-modal .modal
  width 800px !important
</style>